import {useState,useEffect} from 'react'
import {Outlet} from 'react-router-dom'
// import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {Toolbar} from './components/toolbar/Toolbar'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {useLocation} from 'react-router-dom'
import {DrawerMessenger, ActivityDrawer, Main, InviteUsers, UpgradePlan} from '../partials'
import {MenuComponent} from '../assets/ts/components'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faPhoneVolume, faHouse, faTicket } from '@fortawesome/free-solid-svg-icons'
import { styleSetupConfig } from '../../app/configs/style-config';

const MasterLayout = () => {
  const location = useLocation()
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])
  const urlpath =location.pathname;


  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

console.log("urlpath",urlpath);

    /// style web


      console.log("kk");


    let stylesweb = JSON.parse(""+window.sessionStorage.getItem('stylesetup'));

    //AVCDAMOSHI.001  17/03/2025  Add code for  Reuse style setup
    const styles = styleSetupConfig(stylesweb, (result) => {
      return (urlpath!="/login") ? {background_Style: result.background_Style} : 
        {background_Style: {...result.background_Style, "backgroundColor": "#FFF"}};
    });

    // let styles = (urlpath!="/login")?{

    //       background_Style: {
    //         "backgroundColor": stylesweb.background_Style.background_color,
    //         "border": stylesweb.background_Style.border,
    //         "border-color": stylesweb.background_Style.border_color,
    //         "border-radius": stylesweb.background_Style.border_radius,
    //         "color": stylesweb.background_Style.font_color,
    //         "font-family": stylesweb.background_Style.font_name,
    //         "font-size": stylesweb.background_Style.font_size,
    //         "font-weight": stylesweb.background_Style.font_weight,
    //       }

    //     }:{
    //           background_Style: {
    //             "backgroundColor": "#FFF",
    //           },

    //         };

    //C-AVCDAMOSHI.001  17/03/2025  Add code for  Reuse style setup



  return (
    <PageDataProvider>
      {/* <div className='page d-flex flex-row flex-column-fluid'> */}
        {/* <AsideDefault /> */}
        {/* <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'> */}

          <HeaderWrapper />
        <div id='kt_content' className='content d-flex flex-column flex-column-fluid' style={styles.background_Style}>
            <Toolbar />
            <div className='post d-flex flex-column-fluid' id='kt_post'>
              <Content>
                <Outlet />
              </Content>
            </div>
          </div>


          <Navbar  className={ (urlpath=="/editeMember"||urlpath=="/homepage"||urlpath=="/contact"
          //AVCDAAV.002  20/03/2025  Add code for adding codition for display coupon page
          || urlpath=="/coupon" || urlpath=="/change-mobile-phone" || urlpath.match(/^\/coupon\/([^/]+)$/)
          //C-AVCDAAV.002  20/03/2025  Add code for adding codition for display coupon page
          )?"sticky-bottom-show sticky-bottom pt-0 pb-1":"sticky-bottom-non sticky-bottom pt-0 pb-1"} bg="white" variant="white" >
            <Container className="flex-row">
              {/* <Navbar.Brand href="#home">Navbar</Navbar.Brand> */}
              {/* <Nav> */}
                <NavLink to="/homepage"  
                //AVCDAAV.001  11/03/2025  Add code for adding custom style in the future.
                // className={({ isActive }) => (isActive ? 'text-center text-info m-5 w-auto flex-fill' : 'text-center text-muted m-5 w-auto flex-fill')}
                className={'text-center m-5 w-auto flex-fill'}
                style={({isActive}) => ( isActive  ? 
                  // styles.icon_style 
                  styles.icon_style
                  :{ color: '#A1A5B7' })}
                //C-AVCDAAV.001  11/03/2025  Add code for adding custom style in the future.
                >
                  {/* className="" */}
                  <FontAwesomeIcon icon={faHouse} size="2x"/>
                   <p className="mb-0">Home</p>
                </NavLink>
                <NavLink to="/editeMember" 
                //AVCDAAV.001  11/03/2025  Add code for adding custom style in the future.
                // className={({ isActive }) => (isActive ? 'text-center text-info m-5 w-auto flex-fill' : 'text-center text-muted m-5 w-auto flex-fill')}
                className={'text-center m-5 w-auto flex-fill'}
                style={({isActive}) => ( isActive  ? 
                  // styles.icon_style 
                  styles.icon_style
                  :{ color: '#A1A5B7' })}
                //C-AVCDAAV.001  11/03/2025  Add code for adding custom style in the future.
                >
                <FontAwesomeIcon icon={faUser} size="2x"/>
                  <p className="mb-0">Profile</p>
                </NavLink>
                <NavLink to="/coupon"
                //AVCDAAV.001  11/03/2025  Add code for adding custom style in the future.
                // className={({ isActive }) => (isActive ? 'text-center text-info m-5 w-auto flex-fill' : 'text-center text-muted m-5 w-auto flex-fill')}
                className={'text-center m-5 w-auto flex-fill'}
                style={({isActive}) => ( isActive  ? 
                  // styles.icon_style 
                  styles.icon_style
                  :{ color: '#A1A5B7' })}
                //C-AVCDAAV.001  11/03/2025  Add code for adding custom style in the future.
                >
                <FontAwesomeIcon icon={faTicket} size="2x"/>
                  <p className="mb-0">Coupon</p>
                </NavLink>
                <NavLink to="/contact" 
                //AVCDAAV.001  11/03/2025  Add code for adding custom style in the future.
                // className={({ isActive }) => (isActive ? 'text-center text-info m-5 w-auto flex-fill' : 'text-center text-muted m-5 w-auto flex-fill')}
                className={'text-center m-5 w-auto flex-fill'}
                style={({isActive}) => ( isActive  ? 
                  // styles.icon_style 
                  styles.icon_style
                  :{ color: '#A1A5B7' })}
                //C-AVCDAAV.001  11/03/2025  Add code for adding custom style in the future.
                >
                <FontAwesomeIcon icon={faPhoneVolume} size="2x"/>
                  <p className="mb-0">Contact us</p>
                </NavLink>
              {/* </Nav> */}
            </Container>
          </Navbar>
          <Footer />
        {/* </div> */}
      {/* </div> */}

      {/* begin:: Drawers */}
      <ActivityDrawer />
      <RightToolbar />
      <DrawerMessenger />
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      <Main />
      <InviteUsers />
      <UpgradePlan />
      {/* end:: Modals */}
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
